
<form class="layout-form" [formGroup]="customerForm"(ngSubmit)="onSubmit()">
  <div class="component-content">
    <div *ngIf="isEmail && !statusInitial" class="form-header">
      <p>Validacion Email</p>
      <span [hidden]="verificationSuccess" class="informative-text">Se ha enviado un correo electrónico de verificación a <span class="email-text">{{email}}</span> Verifique su correo electrónico y ingrese el código recibido para verificar su dirección de correo electrónico.
      </span>
    </div>
    <div *ngIf="!isEmail && !statusInitial" class="form-header">
      <p>Validacion Numero Telefono</p>
      <span [hidden]="verificationSuccess" class="informative-text">
        Se ha enviado un mensaje de verificación a <span class="email-text">{{phone}}</span>. Verifique su número de teléfono e ingrese el código recibido para verificar su número.
      </span> 
    </div>
    <div *ngIf="statusInitial" class="form-header">
      <p>Seleccione un Método de Verificación</p>
      <span [hidden]="verificationSuccess" class="informative-text">
        Elija un método de verificación: puede recibir un código en su correo electrónico o en su número de teléfono.
      </span> 
    </div>
    <div class="validation-phone">
      <label  >
        <input [attr.disabled]="!customerForm.controls['timer'].value ? '' : null" type="radio" value="true" formControlName="isEmail" (change)="toggleValidationMethod(true)">
        Validar por Correo Electrónico
      </label>
      <label>
        <input [attr.disabled]="!customerForm.controls['timer'].value ? '' : null" type="radio"  value="false" formControlName="isEmail"  (change)="toggleValidationMethod(false)">
        Validar por Teléfono
      </label>
    </div>
    <div *ngIf="!verificationSuccess" > 
        <div class="code-inputs">
          <input *ngFor="let c of codeArray; let i = index" type="text" maxlength="1" class="code-input"
          formControlName="code{{i}}" name="code{{i}}" (keydown)="onKeydown($event, i)" (paste)="onPaste($event, i)">
          </div>
          <div class="button-code-container">
          <div class="timer-conteiner">
            <app-timer formControlName="timer" ></app-timer>
          </div>
          <div>
            <button class="resendBtn" [disabled]="!customerForm.controls['timer'].value" (click)="resendCode()">Reenviar código</button>
          </div>
          <div>
            <button [disabled]="!this.customerForm.valid" mat-raised-button class="btn-verify-code" type="button"  (click)="verifyCode()">Verificar Código</button>
            <p *ngIf="verificationError" class="code-error-text">{{ verificationError }} <mat-icon>error</mat-icon> </p>
          </div>
        </div>
  </div>
    <div  *ngIf="verificationSuccess" class="component-content">
      <p class="code-correct"> ¡Código Correcto! <mat-icon class="icon-correct">local_post_office</mat-icon> </p>
    </div>
  </div>
  <div class="form-navigation pad">
    <app-navigation [currentStep]="6" [countSteppers]="6"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Anterior</button>
    <button [disabled]="!verificationSuccess" mat-raised-button class="next-button next-button__60" type="submit">Siguiente</button>
  </div>
</form>
